export var getVisiblePages = function (mobile, numberOfVisiblePages, page, pageCount) {
    if (!page)
        return [];
    if (pageCount <= 10 && !mobile) {
        numberOfVisiblePages = 10;
    }
    if (pageCount <= 5 && mobile) {
        numberOfVisiblePages = 5;
    }
    var numberOfVisible = numberOfVisiblePages;
    var min = page % numberOfVisible === 0 ? page - (numberOfVisible - 1) : page - (page % numberOfVisible) + 1;
    var pages = new Array(numberOfVisible + 1)
        .join('0')
        .split('')
        .map(function (x, i) { return min + i; });
    var ret = pages.filter(function (x) { return x <= pageCount; });
    return handleRemainder(ret, numberOfVisible);
};
export var goBackAPageRange = function (mobile, numberOfVisiblePages, page, pageCount, e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    var currentRange = getVisiblePages(mobile, numberOfVisiblePages, page, pageCount);
    var start = currentRange[0] - numberOfVisiblePages;
    start = start > 0 ? start : 1;
    var visiblePages = Array.from({ length: numberOfVisiblePages }, function (v, k) { return k + start; });
    return visiblePages[visiblePages.length - 1];
};
export var goForwardAPageRange = function (mobile, numberOfVisiblePages, page, pageCount, e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    var currentRange = getVisiblePages(mobile, numberOfVisiblePages, page, pageCount);
    return currentRange[numberOfVisiblePages - 1] + 1;
};
export var getPageRangeStart = function (itemCount, pageCount, pageSize, page) {
    if (itemCount <= 0)
        return 0;
    return pageCount > 0 ? page * pageSize - (pageSize - 1) : 0;
};
export var getPageRangeEnd = function (itemCount, pageCount, pageSize, page) {
    if (itemCount <= 0)
        return 0;
    return page === pageCount ? itemCount - (pageSize - 1) * page + (pageSize - 1) * page : page * pageSize;
};
// PRIVATE:
var handleRemainder = function (pages, numberOfVisible) {
    if (!pages.length || (pages.length && pages.length === numberOfVisible))
        return pages;
    var temp = [];
    var numberMissing = numberOfVisible - pages.length;
    var arrayMissing = new Array(numberMissing).fill(0, 0, numberMissing);
    arrayMissing.forEach(function (x, i) {
        var backfill = pages[0] - numberMissing + i;
        if (backfill > 0) {
            temp.push(backfill);
        }
    });
    pages.forEach(function (x) { return temp.push(x); });
    return temp;
};
